<!-- 首页信息 -->
<template>
  <div class="home_main_list">
    <ul class="task_list clearfix">
      <li class="fl"
          v-for='item in taskList'
          :key='item.id'
          @click="taskLink(item.path)">
        <img :src='item.pic' />
        <p>{{item.name}}&nbsp;&gt;</p>
      </li>
    </ul>
  </div>
</template>

<script>
import appointment from '@/assets/undergraduate/images/appointment.png'
import completeCv from '@/assets/undergraduate/images/complete_cv.png'
export default {
  name: '',
  components: {},
  data () {
    return {
      appointment,
      completeCv,
      // 首页任务列表
      taskList: [
        {
          id: 'cv',
          name: '完善简历信息',
          pic: appointment,
          path: '/undergraduate/cv'
        },
        // TODO:暂时隐藏
        {
          id: 'service',
          name: '预约导师',
          pic: completeCv,
          path: '/undergraduate/service/team'
        }
      ]
    }
  },
  computed: {},
  mounted () {
  },
  methods: {
    // 首页列表项跳转
    taskLink (pathName) {
      this.$router.push({
        path: pathName
      })
    }
  }
}
</script>
<style lang='less' scoped>
.clearfix {
  *zoom: 1;
}
.clearfix::after {
  content: "";
  display: block;
  clear: both;
}
.fl {
  float: left;
}
.home_main_list {
  width: 1280px;
  box-sizing: border-box;
  padding: 20px 0;
  margin: 0 auto;
  .task_list {
    padding-top: 20px;
    margin: 0 auto;
    li {
      width: 224px;
      height: 230px;
      margin: 0 22px;
      background: #fff;
      cursor: pointer;
      padding-top: 22px;
      box-shadow: 0 4px 8px 0 #e9f0fa;
      img {
        width: 194px;
        height: 134px;
        margin: 0 auto;
      }
      p {
        line-height: 40px;
        font-size: 16px;
        color: #667483;
        letter-spacing: 0;
        text-align: center;
      }
    }
  }
}
</style>
